import { makeStyles } from "tss-react/mui";
import { Grid, Tabs, Tab } from "@mui/material";
import { useTranslation } from "react-i18next";
import ResponsivePage from "../../common/core/ResponsivePage";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback } from "react";
import RequestedPaymentsSection from "./subpages/RequestedPaymentsSection";
import CashOrdersReadyForJournalingSection from "./subpages/CashOrdersReadyForJournalingSection";
import CashJournalsSection from "./subpages/CashJournalsSection";
import CashJournalEntriesSection from "./subpages/CashJournalEntriesSection";
import config from "../../../config";
import { useDevice } from "../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    tabs: {
      marginBottom: theme.spacing(3),
      borderBottom: `1px solid ${theme.palette.divider}`
    },
    tabsSlim: {
      borderBottom: `1px solid ${theme.palette.divider}`
    }
  })
);

export default function CashOrdersPage() {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { tabId } = useParams();
  const { slim } = useDevice();

  const navigate = useNavigate();
  const onTabChange = useCallback((_, val) => navigate(!!tabId ? `../${val}` : `./${val}`, { relative: "path", replace: true }), [navigate, tabId]);

  return (
    <ResponsivePage
      title={t("cashOrders:title")}
      maxWidth={config.pageSize.huge}
    >

      <Grid item xs={12}>
        <Tabs className={slim ? classes.tabsSlim : classes.tabs} value={tabId || "requested"} onChange={onTabChange} variant="scrollable" scrollButtons="auto">
          <Tab value="requested" label={t("cashOrders:paymentRequestedTab")} />
          <Tab value="ready" label={t("cashOrders:readyForJournalingTab")} />
          <Tab value="journals" label={t("cashOrders:journalsTab")} />
          <Tab value="journalentries" label={t("cashOrders:journalEntriesTab")} />
        </Tabs>
      </Grid>

      {
        !tabId || tabId === "requested" ? (
          <RequestedPaymentsSection />
        ) : tabId === "ready" ? (
          <CashOrdersReadyForJournalingSection />
        ) : tabId === "journals" ? (
          <CashJournalsSection />
        ) : tabId === "journalentries" ? (
          <CashJournalEntriesSection />
        ) : null
      }

    </ResponsivePage>
  );
}

